<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Copyright</h1>
</div>
</div>
<p class="double" style="text-align: center;">
<span style="font-size: 1em; line-height: 1.5; text-indent: 0em;">Diversion Books</span><br/>
	A Division of Diversion Publishing Corp.<br/>
	443 Park Avenue South, Suite 1004<br/>
	New York, NY 10016<br/>
<a href="http://www.DiversionBooks.com" target="_blank">www.DiversionBooks.com</a></p>
<p class="double" style="text-align: center;">
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">Copyright © 1981 by Martha Kay Renfroe</span><br/>
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</span></p>
<p class="double" style="text-align: center;">
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">For more information, email <a href="mailto:info@diversionbooks.com">info@diversionbooks.com</a>.</span></p>
<p class="double" style="text-align: center;">
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">First Diversion Books edition July 2013</span><br/>
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">ISBN: </span><span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em; font-family: 'Liberation Serif', serif; text-align: justify;">978-1-62681-099-0</span></p>
<div style="page-break-after: always;">
<div style="display: none;">
</div>
</div>
<h3>
	Also by M.K. Wren</h3>
<p class="first" style="text-align: center;">
<span href="#/Text/chap159684" title="Link target outside of Sample">A Gift Upon the Shore</span></p>
<p class="first" style="text-align: center;">
<em><strong>The Phoenix Legacy</strong></em><br/>
<span href="#/Text/chap159684" title="Link target outside of Sample"><span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">Sword of the Lamb (Book One of the Phoenix Legacy)</span><br/>
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">Shadow of the Swan (Book Two of the Phoenix Legacy)</span></span></p>
<p>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005copyright.vue?25cc3534